import { ClassicGameDefinition } from './ClassicGameDefinition';
import { partnerSettingsStore } from '../business/PartnerSettings';
import { GameId } from '../enums/GameId';

export const isForceMuted = (gameId: GameId) =>
    partnerSettingsStore.isBrazilJurisdiction &&
    ClassicGameDefinition.BRAZIL_MUTED_GAMES_IDS.includes(gameId);
